import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import Footer from './components/Footer';
import './lighting.css';

export default function LightingLayout() {
  return (
    <div className="lighting-app relative min-h-screen" dir="rtl">
      <Outlet />
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}
